<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">บันทึกบัญชี</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_add_data" elevation="4" @click="add_account = true" large>บันทึกบัญชี</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title>
              <v-row>
                <v-col xs="12" sm="6" md="3" lg="2" xl="2" cols="12">
                  <v-select color="#D6BFAF" class="input-radius" :items="month" item-text="name" item-value="id"
                    v-model="selected_month" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน"
                    hide-details="auto" @change="getAccountMainList()" single-line outlined dense></v-select>
                </v-col>
                <v-col xs="12" sm="6" md="3" lg="2" xl="2" cols="12">
                  <v-select color="#D6BFAF" class="input-radius" :items="year_arr" item-text="show_year"
                    item-value="year_eng" v-model="selected_year" prepend-inner-icon="mdi-calendar-month-outline"
                    label="ปี พ.ศ." hide-details="auto" @change="getAccountMainList()" single-line outlined dense></v-select>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="8" xl="8" cols="12">
                  <v-text-field color="#D6BFAF" class="input-radius inp-text-field" append-icon="mdi-magnify"
                    style="float: right;" hide-details="auto" required v-model="search" placeholder="ค้นหา..." single-line
                    outlined dense></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-data-table :headers="headers" :items="account_main_list" :search="search"
                    :footer-props="footer_Props">
                    <template v-slot:item="dataDetail">
                      <tr>
                        <td class="hidden_line pa-3">
                          <div>{{ dateTodayFormat(dataDetail.item.date_create) }}</div>
                        </td>
                        <td class="hidden_line">
                          <div class="d-flex">
                            <div class="mr-2">{{ dataDetail.item.account_name }}</div>
                            <v-tooltip v-if="dataDetail.item.description_update != null" color="#a2a2a2"
                              class="input-radius" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-message-bulleted</v-icon>
                              </template>
                              <div style="width:350px">
                                <v-row>
                                  <v-col cols="12 py-1 pt-3">
                                    {{ dateTimeTodayFormat(dataDetail.item.update_at) }}
                                  </v-col>
                                  <v-col cols="12 py-1">
                                    หมายเหตุการแก้ไข : {{ dataDetail.item.description_update }}
                                  </v-col>
                                  <v-col cols="12 text-right pb-4">
                                    โดย {{ dataDetail.item.user_edit }}
                                  </v-col>
                                </v-row>
                                <div></div>
                              </div>
                            </v-tooltip>
                          </div>
                        </td>

                        <td class="hidden_line">
                          <div>{{ dataDetail.item.name_type }}</div>
                        </td>
                        <td class="hidden_line">
                          <div v-if="dataDetail.item.type == 0" class="text-center" style="color: #88B358">{{
                            format_price(dataDetail.item.prices)
                          }}</div>
                          <div v-else class="text-center">-</div>
                        </td>
                        <td class="hidden_line">
                          <div v-if="dataDetail.item.type == 1" class="text-center" style="color: #F28080">{{
                            format_price(dataDetail.item.prices)
                          }}</div>
                          <div v-else class="text-center">-</div>
                        </td>
                        <td class="hidden_line text-center">
                          {{ format_price(dataDetail.item.total_price) }}
                        </td>
                        <td v-if="dataDetail.item.description != ''" class="hidden_line">
                          <div>{{ dataDetail.item.description }}</div>
                        </td>
                        <td v-else class="hidden_line">
                          -
                        </td>
                        <td class="hidden_line">
                          <div>{{ dataDetail.item.user_name }}</div>
                        </td>
                        <td class="hidden_line">
                          <v-btn elevation="4" class="ma-2" outlined @click="detail_acc(dataDetail.item.id)"
                            color="#8EBBDC" style="border-radius: 10px;" small height="45" title="ดูรายละเอียด">
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                          <v-btn elevation="4" class="ma-2" outlined @click="update_acc(dataDetail.item.id)"
                            color="#FEA06C" style="border-radius: 10px;" small height="45" title="แก้ไขรายละเอียด">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- ADD -->
      <v-dialog v-model="add_account" persistent max-width="650">
        <v-card>
          <v-form ref="form" @submit.prevent="createAccountingHistroy">
            <div class="d-flex justify-space-between">
              <v-card-title>
                <b>เพิ่มรายการบัญชี</b>
              </v-card-title>
              <v-btn icon class="ma-4" @click="add_account = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-radio-group v-model="input_set.type" hide-details="auto" row @change="getAccountList();">
                    <v-radio color="#D6BFAF" label="เงินเข้า" :value="0"></v-radio>
                    <v-radio color="#D6BFAF" label="เงินออก" :value="1"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col sm="12" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">วันที่สร้าง <span class="required--text">*</span></label>
                    <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field clearable color="#D6BFAF" class="input-radius" v-model="input_set.date_create"
                          hide-details="auto" label="กรุณาเลือกวันที่สร้างรายการบัญชี"
                          :rules="[v => !!v || 'กรุณาเลือกวันที่สร้างรายการบัญชี']" prepend-inner-icon="mdi-calendar"
                          readonly v-bind="attrs" v-on="on" single-line outlined dense required></v-text-field>
                      </template>
                      <v-date-picker locale="TH" color="#D6BFAF" v-model="input_set.date_create" :min="start_date"
                        @change="selectDate()" no-title scrollable :show-current="start_date">
                        <!-- <v-spacer></v-spacer>
                        <v-btn text color="#D6BFAF" @click="selectDate()">
                          ตกลง
                        </v-btn>
                        <v-btn text color="#D6BFAF" @click="menu_date = false">
                          ยกเลิก
                        </v-btn> -->
                      </v-date-picker>
                    </v-menu>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ประเภทบัญชี <span class="required--text">*</span></label>
                    <v-autocomplete color="#D6BFAF" class="input-radius" :items="account_list" item-text="name_type"
                      item-value="id" v-model="input_set.account_type" :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']"
                      hide-details="auto" placeholder="กรุณาเลือกประเภทบัญชี" single-line outlined dense
                      required></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ชื่อรายการ <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-calculator"
                      hide-details="auto" v-model="input_set.account_name"
                      :rules="[v => !!v || 'กรุณากรอกชื่อประเภทบัญชี']" placeholder="กรุณากรอกชื่อประเภทบัญชี" single-line
                      outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">จำนวนเงิน <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cash-multiple"
                      @keypress="isCurrency($event, input_set.prices)" @paste="isPaste($event)" hide-details="auto"
                      v-model="input_set.prices" :rules="[v => !!v || 'กรุณากรอกจำนวนเงิน']"
                      placeholder="กรุณากรอกจำนวนเงิน" single-line outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">รายละเอียด</label>
                    <v-textarea color="#D6BFAF" class="input-radius" hide-details="auto" v-model="input_set.description"
                      placeholder="กรุณากรอกรายละเอียด" single-line outlined dense required></v-textarea>
                  </v-form-group>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" class="btn_add_data_submit" elevation="4" large>บันทึก</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- UPDATE -->
      <v-dialog v-model="update_account" persistent max-width="650">
        <v-card>
          <v-form ref="form" @submit.prevent="editAccountingHistroy">
            <div class="d-flex justify-space-between">
              <v-card-title>
                <b>แก้ไขรายการบัญชี</b>
              </v-card-title>
              <v-btn icon class="ma-4" @click="update_account = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-radio-group v-model="account_main_edit.type" row @change="getAccountListEdit();">
                    <v-radio color="#D6BFAF" label="เงินเข้า" :value="0"></v-radio>
                    <v-radio color="#D6BFAF" label="เงินออก" :value="1"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ประเภทบัญชี <span class="required--text">*</span></label>
                    <v-autocomplete color="#D6BFAF" class="input-radius" :items="account_list_edit" item-text="name_type"
                      item-value="id" v-model="account_main_edit.account_type"
                      :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']" hide-details="auto"
                      placeholder="กรุณาเลือกประเภทบัญชี" single-line outlined dense required></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ชื่อรายการ <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-calculator"
                      hide-details="auto" v-model="account_main_edit.account_name"
                      :rules="[v => !!v || 'กรุณากรอกชื่อประเภทบัญชี']" placeholder="กรุณากรอกชื่อประเภทบัญชี" single-line
                      outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">จำนวนเงิน <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cash-multiple"
                      hide-details="auto" v-model="account_main_edit.prices" :rules="[v => !!v || 'กรุณากรอกจำนวนเงิน']"
                      placeholder="กรุณากรอกจำนวนเงิน" single-line outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">รายละเอียด</label>
                    <v-textarea color="#D6BFAF" class="input-radius" hide-details="auto"
                      v-model="account_main_edit.description" placeholder="กรุณากรอกรายละเอียด" single-line outlined dense
                      required></v-textarea>
                  </v-form-group>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12" v-if="input_set.account_type !== 0">
                  <v-form-group>
                    <label class="label_form_text">หมายเหตุการแก้ไข </label>
                    <v-textarea color="#D6BFAF" class="input-radius" hide-details="auto"
                      v-model="account_main_edit.description_update" placeholder="หมายเหตุการแก้ไข" single-line outlined
                      dense required></v-textarea>
                  </v-form-group>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" class="btn_add_data_submit" elevation="4" large>บันทึก</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- details -->
      <v-dialog v-model="detail_account" persistent max-width="900">
        <v-card>
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>รายละเอียดบัญชี</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="detail_account = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <div class="mt-3 mb-3">
                  <v-chip v-if="(account_main_detail.type == 1)" style="font-size:16px;" color="#F28080"
                    outlined>เงินออก</v-chip>
                  <v-chip v-else style="font-size:16px;" color="#88B358" outlined>เงินเข้า</v-chip>
                  <span class="ml-2" style="font-size:16px;">วันที่สร้างรายการบัญชี : <span
                      style="color:#616A6B;font-weight: 600;">{{
                        dateTimeTodayFormat(account_main_detail.date_create)
                      }}</span></span>
                </div>
              </v-col>
              <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <div class="mt-3 mb-3 text-center">
                  <span class="ml-2" style="font-size:16px;">โดย : <span style="color:#616A6B;font-weight: 600;">{{
                    account_main_detail.create_by
                  }}</span></span>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                <v-divider></v-divider>
                <div class="mt-3 mb-3">
                  <v-chip v-if="(account_main_detail.type == 1)" style="font-size:24px;padding: 28px;" color="#F28080"
                    outlined>{{
                      format_price(account_main_detail.prices)
                    }} บาท</v-chip>

                  <v-chip v-else style="font-size:24px;padding: 28px;" color="#88B358" outlined>{{
                    format_price(account_main_detail.prices)
                  }} บาท</v-chip>
                </div>
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
                <div class="mt-3 mb-3">
                  <span class="ml-2" style="font-size:16px;">ชื่อรายการ : <span style="color:#616A6B;font-weight: 600;">{{
                    account_main_detail.account_name }}</span></span>
                </div>
                <div class="mt-3 mb-3">
                  <span class="ml-2" style="font-size:16px;">ประเภทบัญชี : <span
                      style="color:#616A6B;font-weight: 600;">{{ account_main_detail.name_type }}</span></span>
                </div>
              </v-col>
              <v-col v-if="account_main_detail.description != ''" xs="12" sm="12" md="12" lg="12" xl="12" cols="12"
                class="pt-0 mt-0">

                <span class="ml-2" style="font-size:16px;">รายละเอียด : <span style="color:#616A6B;font-weight: 600;">{{
                  account_main_detail.description
                }}</span></span>

              </v-col>
              <v-col v-else xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pt-0 mt-0">
                <span class="ml-2" style="font-size:16px;">รายละเอียด : <span
                    style="color:#616A6B;font-weight: 600;">-</span></span>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div style="padding:20px;border:1px solid #FEA06C;border-radius: 10px;">
                  <span style="color: #FEA06C;font-size:16px;font-weight: 600;">หมายเหตุการแก้ไข</span>
                  <v-data-table :headers="header_detail" :items="account_main_detail_log" :footer-props="footer_Props"
                    mobile-breakpoint="0">
                    <template v-slot:item="dataDetail">
                      <tr>
                        <td class="hidden_line">
                          <div>{{ dateTimeTodayFormat(dataDetail.item.create_at) }}</div>
                        </td>
                        <td class="hidden_line">
                          <div v-if="dataDetail.item.description_update == null">-</div>
                          <div v-else>{{ dataDetail.item.description_update }}</div>
                        </td>
                        <td class="hidden_line">
                          <div>{{ dataDetail.item.edit_by }}</div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { minDate } from "@/js/handler";
import { isTelephone, taxNumber, validateEmail, onPaste, formatPrice, onlyForCurrency } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Account_history",
  data() {
    return {
      loading_page: false,
      search: '',
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu_date: false,
      add_account: false,
      update_account: false,
      detail_account: false,
      start_date: this.min_date(),

      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'บัญชี',
          disabled: false,
        },
        {
          text: 'บันทึกบัญชี',
          disabled: false,
          href: '#',
        }
      ],
      month: this.$store.state.monthList,
      selected_month: null,
      selected_year: null,
      year_arr: [],
      account_list: null,
      account_list_edit: null,
      account_main_list: [],
      account_main_edit: [],
      account_main_detail: [],
      account_main_detail_log: [],
      input_set: {
        type: '',
        date_create: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        account_name: '',
        account_type: '',
        prices: '',
        description: '',
      },
      header_detail: [
        {
          text: 'วันที่/เวลา',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'หมายเหตุการแก้ไข',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'ผู้ดำเนินการ',
          value: '',
          fixed: true,
          align: 'left',
        },
      ],
      headers: [
        {
          text: 'วันที่',
          value: 'date_create',
          fixed: true,
          align: 'left',
          sortable: true,
          width: 100,
        },
        {
          text: 'ชื่อรายการ',
          value: 'account_name',
          fixed: true,
          align: 'left',
          width: 220,
        },
        {
          text: 'ประเภทบัญชี',
          value: 'name_type',
          fixed: true,
          align: 'left',
          width: 140,
        },
        {
          text: 'รายรับ',
          value: 'prices',
          fixed: true,
          align: 'center',
          width: 120,
        },
        {
          text: 'รายจ่าย',
          value: 'prices',
          fixed: true,
          align: 'center',
          width: 120,
        },
        {
          text: 'คงเหลือ',
          value: 'total_price',
          fixed: true,
          align: 'center',
          width: 120,
        },
        {
          text: 'รายละเอียด',
          value: 'description',
          fixed: true,
          width: 150,
        },
        {
          text: 'ผู้สร้าง',
          value: 'user_name',
          fixed: true,
          width: 150,

        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: 180,
        },
      ],
    }
  },
  methods: {
    // GET ข้อมูลบัญชี
    getAccountList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/detailmaintype', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.account_list = res.data.TypeDetail;
          let value = res.data.TypeDetail.filter((res) => {
            return res.in_ex == this.input_set.type
          });
          this.account_list = value;
          this.account_list_edit = value;
        }
      })
    },
    getAccountListEdit() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/detailmaintype', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.account_list_edit = res.data.TypeDetail;
          let value = res.data.TypeDetail.filter((res) => {
            return res.in_ex == this.account_main_edit.type
          });
          this.account_list_edit = value;
        }
      })
    },

    // GET ข้อมูลบันทึกบัญชี
    getAccountMainList() {
      this.loading_page = false;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/detailmain?month=' + this.selected_month + '&year=' + this.selected_year, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.account_main_list = res.data.mainDetail;
          const main_length = res.data.mainDetail.length
          let total_price = 0
          for (let index = main_length - 1; index >= 0; index--) {
            if (this.account_main_list[index].type == 0) {
              total_price += parseFloat(this.account_main_list[index].prices)
            }
            if (this.account_main_list[index].type == 1) {
              total_price -= parseFloat(this.account_main_list[index].prices)
            }
            this.account_main_list[index].total_price = total_price.toFixed(2)
          }
        }
      })
    },
    // ฟังค์ชั่น การนำไป save
    createAccountingHistroy() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      if (this.$refs.form.validate()) {
        var dt = new Date()
        this.input_set.date_create = this.input_set.date_create + ' ' + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
        HTTP_ARIN.post('/account/add', this.input_set, config)
          .then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          })
      }
    },
    // get ข้อมูลแก้ไข
    update_acc(id) {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/book/edit/' + id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.account_main_edit = res.data.accountBook;
          HTTP_ARIN.get('/account/detailmaintype', config).then((resType) => {
            if (resType.data.successful === true) {
              this.loading_page = false;
              this.account_list_edit = resType.data.TypeDetail;


              let value = resType.data.TypeDetail.filter((resType) => {
                return resType.in_ex == res.data.accountBook.type
              });
              console.log(value);
              this.account_list_edit = value;

            }
          })

          this.update_account = true
        }
      })
    },
    // ฟังค์ชั่น การนำไป edit
    editAccountingHistroy() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      if (this.$refs.form.validate()) {
        HTTP_ARIN.post('/account/book/update/' + this.account_main_edit.id, this.account_main_edit, config)
          .then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'แก้ไขข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          })
      }
    },
    detail_acc(id) {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/book/detail/' + id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.account_main_detail = res.data.obj.accountBook;
          this.account_main_detail_log = res.data.obj.accountBookLog;
          this.detail_account = true
          console.log(this.account_main_detail);
        }
      })
    },
    link(link) {
      window.location.href = link;
    },
    async year_function() {
      this.year_arr = []
      let arr_year = 21
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      let month_selected = count_year.getMonth() + 1
      for (let i = 0; i < arr_year; i++) {
        let count_th = ((full_year + 543) + i);
        let count_eng = ((full_year) + i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_month = month_selected
      this.selected_year = this.year_arr[0].year_eng
    },
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.input_set.date_create)
      this.menu_date = false
    },
    save_account() {
      // this.add_account = false
      this.$refs.add_form.resetValidation()
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '-' + month + '-' + year
      return this.date = final_date
    },
    dateTodayFormat(value) {
      const dt = new Date(value);
      return `${(dt.getDate())}/${(dt.getMonth() + 1)}/${dt.getFullYear() + 543}`;
    },
    dateTimeTodayFormat(value) {
      const dt = new Date(value);
      if (dt.getMinutes() < 10 && dt.getSeconds() < 10) {
        return `${(dt.getDate())}/${(dt.getMonth() + 1)}/${dt.getFullYear() + 543} ${dt.getHours()} : 0${dt.getMinutes()} : 0${dt.getSeconds()}`;
      } else if (dt.getSeconds() < 10) {
        return `${(dt.getDate())}/${(dt.getMonth() + 1)}/${dt.getFullYear() + 543} ${dt.getHours()} : ${dt.getMinutes()} : 0${dt.getSeconds()}`;
      } else if (dt.getMinutes() < 10) {
        return `${(dt.getDate())}/${(dt.getMonth() + 1)}/${dt.getFullYear() + 543} ${dt.getHours()} : 0${dt.getMinutes()} : ${dt.getSeconds()}`;
      } else {
        return `${(dt.getDate())}/${(dt.getMonth() + 1)}/${dt.getFullYear() + 543} ${dt.getHours()} : ${dt.getMinutes()} : ${dt.getSeconds()}`;
      }
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
  },
  mounted() {
    this.year_function();
    this.getAccountMainList();
  }
}
</script>

<style scoped>
.datepicker_ha .datepicker_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.input-radius {
  border-radius: 10px;
}

.pointer_cursor {
  cursor: pointer;
}

.header_note {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
}

.content_note {
  color: #FFFFFF;
  font-size: 12px;
}

.radio_half {
  display: grid;
  grid-template-columns: 50%;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.mobile_btn {
  width: 25%;
}

.header_text_modal {
  font-weight: 500;
  font-size: 16px;
  color: #616A6B;
}

.header_grid {
  display: grid;
  grid-template-columns: 60% 40%;
}

.tag_status_red {
  border: 1px solid #F28080;
  color: #F28080;
  font-weight: 500;
  font-size: 16px;
  border-radius: 10px;
}

.tag_status_orange {
  border: 1px solid #FEA06C;
  color: #FEA06C;
  font-size: 16px;
  border-radius: 10px;
}

.grid_sub_header {
  display: grid;
  grid-template-columns: 30% 70%;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 100% !important;
}

.inp-text-field {
  width: 23%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100% !important;
  }
}

@media only screen and (max-width: 600px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .inp-text-field {
    width: 100%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .inp-text-field {
    width: 50%;
  }
}


/* @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .inp-text-field {
    width: 23%;
  }
} */
</style>